import React from "react";
import type { FC } from "react";

import cn from "classnames";

import { Icon } from "../../../../Icon";
import { createDisplayNameForContentElement } from "../../utils/getDisplayName";
import { createTestIdForContentElement } from "../../utils/getTestId";

import type {
    OmitOfUnion,
    Optional,
    PropsWithBaseNever,
} from "../../../../../types/react";
import type { IconProps } from "../../../../Icon";
import type { ContentTextAndIconView } from "../../types";

import classes from "./ContentIcon.styl";

const CONTENT_ICON_TEST_ID = createTestIdForContentElement("icon");

export type ConstantIconProps = "size";

type ContentBaseProps = Optional<
    PropsWithBaseNever<IconProps, ContentTextAndIconView>,
    "data-tsid"
>;

export type ContentIconProps = OmitOfUnion<ContentBaseProps, ConstantIconProps>;

export const ContentIcon: FC<ContentIconProps> = ({
    view = "primary",
    customColorsStyles,
    ...props
}) => {
    const iconClassName = cn(
        classes["icon"],
        view && classes[`__view-${view}`],
        customColorsStyles,
    );

    return (
        <Icon
            className={iconClassName}
            {...(props as IconProps)}
            data-tsid={CONTENT_ICON_TEST_ID}
        />
    );
};

ContentIcon.displayName = createDisplayNameForContentElement("Icon");

export default ContentIcon;
